import EditableImage from "../../../../components/EditableImage";
import useImage from "../../../../hooks/useImage";
import useMultimedia from "../../../../hooks/useMultimedia";
import useRwas from "../../../../hooks/useRwas";
import useCompany from "../../../../hooks/useCompany";
import RWADataRow from "../components/RWADataRow";
import { useEffect, useState } from "react";
import useAPI from "../../../../hooks/useAPI";
import toast from "react-hot-toast";

export default function Product({ rwa, reloadRwa }) {
  const { activeCompany: company } = useCompany();
  const { convertToBlob } = useImage();
  const { upload } = useMultimedia();
  const { updateRwa } = useRwas();
  const [currencies, setCurrencies] = useState([]);
  const { getCurrencies } = useAPI();
  const data = rwa?.data;
  const usedCurrency = currencies.find(c => c.id === data?.currency?.value) || null;

  const handleUploadImage = async (newImage, key) => {
    if (!company || !company.id) {
      toast.error("No company selected. Cannot upload image.");
      return;
    }
    let fileToUpload = newImage;
    if (!(newImage instanceof File) && !(newImage instanceof Blob)) {
      const { blob, contentType } = await convertToBlob(newImage);
      fileToUpload = new File([blob], "image.png", { type: contentType });
    }
    const fileUrl = await upload(fileToUpload);
    await updateRwa(company.id, rwa.id, {
      params: {
        [key]: { value: fileUrl, type: "image" }
      },
      name: rwa?.name,
      type: rwa?.type,
    });
    reloadRwa && reloadRwa();
  };

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const list = await getCurrencies();
        setCurrencies(list || []);
      } catch (err) {
        setCurrencies([]);
      }
    };
    fetchCurrencies();
  }, []);
  
  return (
    <div className="p-4 space-y-6 mb-4">

      {/* Main Row: Image + Basic Info */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Product Image */}
        <div className="md:col-span-1 h-full">
          <EditableImage
            imageClassName="!h-full object-cover"
            className="!h-full min-h-[300px]"
            image={data?.image?.value}
            onImageChange={(newImage) => handleUploadImage(newImage, "image")}
          />
        </div>

        {/* Basic Info */}
        <div className="md:col-span-2 grid grid-cols-1 gap-4 text-sm">
          <RWADataRow
            field={data?.description}
            param="description"
            title="Description"
          />
          <RWADataRow
            field={data?.collection}
            param="collection"
            title="Collection"
          />
          <RWADataRow
            field={data?.materials}
            param="materials"
            title="Materials"
          />
          <RWADataRow
            field={data?.price}
            param="price"
            title="Price"
          />
          <div className="">
            <p className="text-gray-500 mb-2">Currency</p>
            <select
              className="w-full rounded-md border border-gray-300 px-3 py-2 bg-white"
              value={usedCurrency ? usedCurrency.id : ""}
              onChange={async (e) => {
                if (!company || !company.id) {
                  toast.error("No company selected. Cannot update currency.");
                  return;
                }
                await updateRwa(company.id, rwa.id, {
                  params: {
                    currency: {
                      type: 'text',
                      value: e.target.value
                    }
                  },
                  name: rwa?.name,
                  type: rwa?.type,
                });
                reloadRwa();
              }}
            >
              <option value="" disabled>Select currency</option>
              {currencies.map((currency) => (
                <option key={currency.id} value={currency.id}>
                  {currency.name} ({currency.symbol})
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
